
import React, { useEffect } from "react";

export default function Header() {

  useEffect(() => {
    const hamburger = document.querySelector(".hamburger");
    const mobileMenu = document.querySelector(".mobile-menu");

    if (!hamburger || !mobileMenu) return;

    const toggleMenu = () => {
      mobileMenu.classList.toggle("active");

      document.body.style.overflow = mobileMenu.classList.contains("active")
        ? "hidden"
        : "auto";
    };

    hamburger.addEventListener("click", toggleMenu);

    const handleDropClick = (e) => {
      e.preventDefault();
      const menu = e.currentTarget.nextElementSibling;
      if (menu) {
        menu.classList.toggle("active");
      }
    };

    const dropBtns = document.querySelectorAll(".mobile-drop-btn");
    const subBtns = document.querySelectorAll(".mobile-sub-btn");

    dropBtns.forEach((btn) => {
      btn.addEventListener("click", handleDropClick);
    });

    subBtns.forEach((btn) => {
      btn.addEventListener("click", handleDropClick);
    });

    const links = mobileMenu.querySelectorAll("a");

    const closeMenu = () => {
      mobileMenu.classList.remove("active");
      document.body.style.overflow = "auto";
    };

    links.forEach((link) => {
      link.addEventListener("click", closeMenu);
    });

    return () => {
      hamburger.removeEventListener("click", toggleMenu);

      dropBtns.forEach((btn) => {
        btn.removeEventListener("click", handleDropClick);
      });

      subBtns.forEach((btn) => {
        btn.removeEventListener("click", handleDropClick);
      });

      links.forEach((link) => {
        link.removeEventListener("click", closeMenu);
      });
    };
  }, []);
  return (
    <>
        <div>
    {/*==============================
    TOP BAR
    ===============================*/}
    <div className="topbar">
        <div className="container topbar-inner">
        <div className="topbar-left">
            <div className="topbar-item">
            <i className="fa-solid fa-envelope" />
            <a href="mailto:info@gandhimandelafoundation.com">
                info@gandhimandelafoundation.com
            </a>
            </div>
            <div className="topbar-item">
            <i className="fa-solid fa-phone" />
            <a href="tel:+91 11 3530 1996">
                 +91 11 3530 1996
            </a>
            </div>
        </div>
        <div className="topbar-right">
            <div className="topbar-social">
            <a href="https://www.facebook.com/gandhimandelafoundation" target="_blank">
                <i className="fa-brands fa-facebook-f" />
            </a>
            <a href="https://www.instagram.com/gandhimandelafoundation/" target="_blank">
                <i className="fa-brands fa-instagram" />
            </a>
            <a href="https://x.com/GandhiMandelaHQ" target="_blank">
                <i className="fa-brands fa-x-twitter" />
            </a>
            <a href="https://www.linkedin.com/company/gandhimandelafoundation/" target="_blank">
                <i className="fa-brands fa-linkedin-in" />
            </a>
            </div>
           
        </div>
        </div>
    </div>
    {/* =========================
    NAVBAR
    ========================== */}
    {/* =========================
        NAVBAR (DESKTOP + MOBILE)
    ========================== */}
    <header className="navbar">
        <div className="container nav-inner">
        <a className="logo" href="/">
            <img src="/img/logo/gandhimandelafoundation.png" alt="Gandhi Mandela Foundation Logo" />
        </a>
        {/* DESKTOP MENU */}
        <nav className="nav-links">
            <a href="/">Home</a>
            {/* About Dropdown */}
            <div className="nav-dropdown">
            <a href="#" className="drop-btn">
                About GMF<i className="fa-solid fa-angle-down" />
            </a>
            <div className="dropdown-menu">
                <a href="/about-gmf">About Us</a>
                <a href="/gmfguideline">GMF Guidelines</a>
                <a href="/boardmembers">Board Members</a>
                <a href="/gmfindia">GMF India</a>
                {/* GMF Europe Sub Dropdown */}
                <div className="nav-subdropdown">
                <a href="#" className="sub-btn">
                    GMF Europe <i className="fa-solid fa-angle-right" />
                </a>
                <div className="sub-menu">
                    <a href="/gmfspain">GMF Spain</a>
                </div>
                </div>
                <div className="nav-subdropdown">
                <a href="/gmflatinamerica" className="sub-btn">
                    GMF Latin America <i className="fa-solid fa-angle-right" />
                </a>
                <div className="sub-menu">
                    <a href="#">Bolivia</a>
                    <a href="#">Dominican Republic</a>
                    <a href="#">Colombia</a>
                    <a href="#">Panama</a>
                    <a href="#">Brazil</a>
                    <a href="#">Argentina</a>
                    <a href="#">Cuba</a>
                    <a href="#">Venezuela</a>
                    <a href="#">Costa Rica</a>
                </div>
                </div>
                <a href="/gmf-mexico">GMF Mexico</a>
                <a href="/gmfmalaysia">GMF Malaysia</a>
                <a href="/gmfitaly">GMF Italy</a>
                <a href="/gmfmadagascar">GMF Madagascar</a>
            </div>
            </div>
            <div className="nav-dropdown">
            <a href="#" className="drop-btn">
                Gandhi Mandela Legacy<i className="fa-solid fa-angle-down" />
            </a>
            <div className="dropdown-menu">
                <a href="/journey">Journey</a>
                <a href="/champaran">Champaran</a>
                <a href="/champaran_satyagrah">Champaran Satyagrah</a>
                <a href="/satyagrahaeternaljourney">Satyagraha– An Eternal Journey</a>
            </div>
            </div>
            <div className="nav-dropdown">
                <a href="#" className="drop-btn">Events Gallery<i className="fa-solid fa-angle-down" />
                </a>
                <div className="dropdown-menu">
                    <a href="/gallery">Events</a>
                    <a href="/nelsonmandeladay">Nelson Mandela Day</a>
                    <a href="/yogaday">International Yoga Day</a>
                    <a href="/charitable-activities">Charitable Activities</a>
                    <a href="/chess-for-peace">Chess for Peace</a>
                </div>  
            </div>
            <div className="nav-dropdown">
                <a href="#" className="drop-btn">News &amp; Media<i className="fa-solid fa-angle-down" />
                </a>
                <div className="dropdown-menu">
                    <a href="/news-media">Latest News</a>
                    <a href="/pressrelease">Press Release</a>
                </div> 
            </div>
            <a href="contact">Contact</a>
        </nav>
        
        {/* Hamburger */}
        <button className="hamburger" aria-label="Open Menu">
            <i className="fa-solid fa-bars" />
        </button>
        </div>
        {/* MOBILE MENU */}
        <div className="mobile-menu">
        <a href="/">Home</a>
        {/* ABOUT GMF MOBILE */}
        <div className="mobile-dropdown">
            <button className="mobile-drop-btn">
            About GMF <i className="fa-solid fa-angle-down" />
            </button>
            <div className="mobile-drop-menu">
                <a href="/about-gmf">About Us</a>
                <a href="/gmfguideline">GMF Guidelines</a>
                <a href="/boardmembers">Board Members</a>
                <a href="/gmfindia">GMF India</a>
            {/* GMF Europe */}
            <div className="mobile-subdropdown">
                <button className="mobile-sub-btn">
                GMF Europe <i className="fa-solid fa-angle-down" />
                </button>
                <div className="mobile-sub-menu">
                <a href="/gmfspain">GMF Spain</a>
                </div>
            </div>
            {/* GMF Latin America */}
            <div className="mobile-subdropdown">
                <button className="mobile-sub-btn">
                GMF Latin America <i className="fa-solid fa-angle-down" />
                </button>
                <div className="mobile-sub-menu">
                <a href="/gmflatinamerica">Latin America</a>
                <a href="#">Bolivia</a>
                <a href="#">Dominican Republic</a>
                <a href="#">Colombia</a>
                <a href="#">Panama</a>
                <a href="#">Brazil</a>
                <a href="#">Argentina</a>
                <a href="#">Cuba</a>
                <a href="#">Venezuela</a>
                <a href="#">Costa Rica</a>
                </div>
            </div>
            <a href="/gmf-mexico">GMF Mexico</a>
            <a href="/gmfmalaysia">GMF Malaysia</a>
            <a href="/gmfitaly">GMF Italy</a>
            <a href="/gmfmadagascar">GMF Madagascar</a>
            </div>
        </div>
        {/* GANDHI MANDELA LEGACY MOBILE */}
        <div className="mobile-dropdown">
            <button className="mobile-drop-btn">
            Gandhi Mandela Legacy <i className="fa-solid fa-angle-down" />
            </button>
            <div className="mobile-drop-menu">
            <a href="/journey">Journey</a>
            <a href="/champaran">Champaran</a>
            <a href="/champaran_satyagrah">Champaran Satyagrah</a>
            <a href="/satyagrahaeternaljourney">Satyagraha – An Eternal Journey</a>
            </div>
        </div>
        {/* GALLERY MOBILE */}
        <div className="mobile-dropdown">
            <button className="mobile-drop-btn">
            Events Gallery <i className="fa-solid fa-angle-down" />
            </button>
            <div className="mobile-drop-menu">
                <a href="/gallery">Events</a>
                <a href="/nelsonmandeladay">Nelson Mandela Day</a>
                <a href="/yogaday">International Yoga Day</a>
                <a href="/charitable-activities">Charitable Activities</a>
                <a href="/chess-for-peace">Chess for Peace</a>
            </div>
        </div>
        {/* NEWS & MEDIA MOBILE */}
        <div className="mobile-dropdown">
            <button className="mobile-drop-btn">
            News &amp; Media <i className="fa-solid fa-angle-down" />
            </button>
            <div className="mobile-drop-menu">
                <a href="/news-media">Latest News</a>
                <a href="/pressrelease">Press Release</a>
            </div>
        </div>
        <a href="contact">Contact</a>
        </div>
    </header>
    </div>

    </>
  )
}
